module.exports = __webpack_public_path__ + "img/BRCA3_Fibroblasts.5d0a09ff.png";